import { Edit } from "@mui/icons-material";
import { IconButton, SxProps, Theme } from "@mui/material";
import { useEffect, useState } from "react";
import { TextField } from "src/components";
import Autocomplete from "src/components/Autocomplete";
import kurumKullaniciService from "src/services/Settings/Generals/kurumKullanici.service";
import kurumTarifeService from "src/services/Settings/Generals/kurumTarife.service";
import { useAppDispatch, useAppSelector } from "src/store";
import { KurumModel } from "src/store/Slices/GenelTanimlar/KurumSlice";
import { helper } from "src/utils/helper";
import { AutoCompleteTargetNumber } from "../Types/autocomplete.target";
import ModulEnum from "src/enums/ModulEnum";
import { isVisible } from "src/utils/formAuthHelper";
import { ApiRequest } from "src/models/api.request";
import VwKurumKullaniciDTO from "src/models/Settings/Generals/VwKurumKullaniciDTO";
interface IKurumAutoCompleteProps {
    value?: number;
    name?: string;
    label?: string;
    onChange?: (e: AutoCompleteTargetNumber, v: KurumModel) => void;
    helperText?: string;
    error?: boolean;
    id?: string;
    sx?: SxProps<Theme>;
    pasifDahil?: boolean;
    readonly?: boolean;
    changeButton?: boolean;
    onChangeButtonClick?: () => void;
    required?: boolean;
    onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
    inputRef?: any;
    authCode?: string;
    modul?: ModulEnum;
    kurumTip?: {
        referansDoktorDahil?: boolean;
        sadeceReferansDoktor?: boolean;
    },
}
class KurumState {
    data: Array<KurumModel> = [];
    value: KurumModel = null;
    isFetching: boolean = true;
    errorMessage: string = "";
}
const KurumAutoComplete = (props: IKurumAutoCompleteProps): JSX.Element => {
    const [kurumState, setKurumState] = useState<KurumState>(new KurumState());

    // const kurumState = useAppSelector(s => s.kurum)
    const organizasyon = useAppSelector(s => s.userOrganizasyon)
    const kullaniciId = useAppSelector(s => s.userLogin.userInfo.id)
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (kurumState.isFetching)
            loadData()
    }, [kurumState.isFetching]);

    const loadData = async () => {
        let data = new Array<KurumModel>();
        var req: ApiRequest<VwKurumKullaniciDTO> = {
            filters: {
                groupOperator: "and",
                predicates: [
                    { fieldName: "kullaniciId", operator: "=", value1: kullaniciId ? kullaniciId : 0 },
                ],
            },
            sorts: [
                { fieldName: "adi" }
            ]
        }
        if (!props.kurumTip?.referansDoktorDahil)
            req.filters.predicates.push({ fieldName: "kurumtip", operator: "=", value1: 3, not: true });
        if (props.kurumTip?.sadeceReferansDoktor)
            req.filters.predicates.push({ fieldName: "kurumtip", operator: "=", value1: 3 });
        const resKurum = await kurumKullaniciService.find(req)
        const resKurumTarife = await kurumTarifeService.find({
            filters: {
                groupOperator: "and",
                predicates: [
                    { fieldName: "fkGnlOrganizasyonId", operator: "=", value1: organizasyon.organizasyon.fkOrganizasyon },
                    { fieldName: "sozlesmeNo", operator: "=", value1: null, not: true },
                    { fieldName: "baslangictarih", operator: "<=", value1: helper.datetimeToday() },
                    { fieldName: "bitistarih", operator: ">=", value1: helper.datetimeToday() },
                ]
            }
        })
        resKurum.data?.forEach(e => {
            const kontrol = resKurumTarife.data?.find(f => f?.fkGnlKurumId === e.id);
            data.push({
                ...e,
                sozlesmeNo: kontrol?.sozlesmeNo,
                tarifeId: kontrol?.fkHbsUcretTarifetanimId
            })
        })
        // dispatch(KurumSlice.actions.setState({
        //     ...kurumState,
        //     data: data || [],
        //     isFetching: false,
        //     value: null
        // }))
        setKurumState({
            ...kurumState,
            data: data || [],
            isFetching: false,
            value: null
        })
    }

    useEffect(() => {
        setKurumState({
            ...kurumState,
            value: kurumState.data?.find(f => f?.id === props.value)
        })

        // dispatch(KurumSlice.actions.setState({
        //     ...kurumState,
        //     value: kurumState.data?.find(f => f?.id === props.value)
        // }))
    }, [kurumState.data, props.value])

    return (
        <Autocomplete
            onKeyDown={props.onKeyDown}

            readOnly={props.readonly}
            fullWidth
            freeSolo={false}
            multiple={false}
            sx={props.sx}
            id={props.id}
            value={kurumState.value?.id > 0 ? kurumState.value : null}
            options={props.pasifDahil ? kurumState.data : kurumState.data?.filter(f => f.aktif === "E")}
            filterOptions={(option, state) => {
                return option.filter(f =>
                    helper.UpperCaseAsc(f?.adi).indexOf(helper.UpperCaseAsc(state.inputValue)) > -1 ||
                    helper.UpperCaseAsc(f.sozlesmeNo)?.indexOf(helper.UpperCaseAsc(state.inputValue)) > -1
                )
            }}
            getOptionLabel={(option) => {
                if (!option.adi)
                    return "";
                return option.adi
            }
            }
            renderOption={(props, option) => {
                if (!option?.id)
                    return "";
                return (
                    <li {...props} key={option.id}>
                        {option.adi}
                    </li>
                );
            }}
            isOptionEqualToValue={(o, v) => o.id === v.id}
            onChange={(e, v, r, d) => {
                setKurumState({
                    ...kurumState,
                    value: kurumState.data?.find(f => f?.id === v?.id)
                })
                // dispatch(KurumSlice.actions.setState({
                //     ...kurumState,
                //     value: kurumState.data?.find(f => f?.id === v?.id)
                // }))
                if (props.onChange)
                    props.onChange({ target: { value: v?.id, name: props.name } }, v);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    required={props.required}
                    label={props.label}
                    error={props.error || Boolean(kurumState.errorMessage)}
                    helperText={kurumState.errorMessage || props.helperText}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {props.changeButton &&
                                    <IconButton
                                        disabled={!props.changeButton || !isVisible(props.authCode, props.modul)}
                                        sx={{ padding: 0 }}
                                        onClick={(e) => {
                                            if (props.onChangeButtonClick) props.onChangeButtonClick();
                                        }}
                                    >
                                        <Edit color={"primary"} />
                                    </IconButton>
                                }
                                {params.InputProps.endAdornment}
                            </>
                        )
                    }}
                    inputRef={props?.inputRef}
                />
            )}

        />
    )

}
export default KurumAutoComplete;